import React from 'react'
import { ReactNode } from 'react'
import HomeActionCard from './HomeActionCard'

interface CardHomeAnalyticsProps {
  title: string
  subtitle: string
  icon: ReactNode
  path?: string
  /** Legado: o card do mockup não tem ilustração. Aceito e ignorado. */
  image?: string
}

/** Card de métricas e analytics — delega para o card único da Home. */
export default function CardHomeAnalytics({
  title,
  subtitle,
  icon,
  path,
}: CardHomeAnalyticsProps) {
  return <HomeActionCard icon={icon} title={title} description={subtitle} path={path} />
}
